import { apiService } from './apiService'

export type FlexibleReportFieldMapping = {
  field: string
  label: string
}

export type FlexibleReportDefinition = {
  id: number
  title: string
  sqlQuery: string
  dateField: string | null
  fieldMappings: FlexibleReportFieldMapping[]
  createdAt?: string
  updatedAt?: string
}

export const flexibleReportService = {
  async list() {
    return apiService.get('/reports/flexible')
  },

  async preview(payload: { sqlQuery: string; dateField?: string | null; startDate?: string | null; endDate?: string | null }) {
    return apiService.post('/reports/flexible/preview', payload)
  },

  async create(payload: { title: string; sqlQuery: string; dateField?: string | null; fieldMappings: FlexibleReportFieldMapping[] }) {
    return apiService.post('/reports/flexible', payload)
  },

  async update(id: number, payload: { title: string; sqlQuery: string; dateField?: string | null; fieldMappings: FlexibleReportFieldMapping[] }) {
    return apiService.put(`/reports/flexible/${id}`, payload)
  },

  async run(id: number, payload?: { startDate?: string | null; endDate?: string | null }) {
    return apiService.post(`/reports/flexible/${id}/run`, payload || {})
  },
}
